import Instafeed from 'instafeed.js';

function getFeed(url, widgetIndex) {
  if (url) {
    $.ajax({
      type: 'get',
      dataType: 'json',
      url: url,
      success: function (response) {
        const feed = new Instafeed({
          template:
            '<a href="{{link}}">' +
            '<figure>' +
            '<picture>' +
            '<source srcset="{{image}}" media="(min-width: 768px)" />' +
            '<source srcset="{{image}}" media="(min-width: 1024px)" />' +
            '<img title="{{caption}}" alt="{{caption}}" src="{{image}}" />' +
            '</picture>' +
            '</figure>' +
            '</a>',
          accessToken: response.Token,
          target: 'instafeed' + (widgetIndex ? '-' + widgetIndex : ''),
          limit: 8
        });

        feed.run();
      }
    });
  }
}

const feed = {
  get: ($instagramFeeds) => {
    // For each Instagram feed element configured in Page Designer, get the URL and widget index
    $instagramFeeds.each(function (index, elem) {
      const $this = $(elem);
      const url = $this.data('url');
      const widgetIndex = $this.data('widget-index');

      getFeed(url, widgetIndex);
    });
  }
};

export default feed;
